import React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";

const DateComponent = (props: any) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DesktopDatePicker
        label={props.label ? props.label : "Date"}
        format={props.dateFormat ? props.dateFormat : "dd/MM/yyyy"}
        disableFuture
        value={props.value ? props.value : null}
        onChange={props.onChange}
        slotProps={{
          textField: {
            error: props.error ? true : false,
            id: props.inputId,
            name: props.inputName,
            size: props.size ? props.size : "small",
            value: props.inputValue ? props.inputValue : null,
            sx: { minWidth: "100%" },
            helperText: props.helperText,
            onBlur: props.inputOnBlur,
            onChange: props.inputOnChange,
            autoComplete: "off",
          },  
        }}
      />
    </LocalizationProvider>
  );
};

export default DateComponent;
